import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';

const DialogMLStyled = styled(Dialog)`
  .MuiDialog-paperWidthMd {
    min-width: ${(props) =>
      props.minwidthinit ? props.minwidthinit + 'px' : '67%'};
    max-width: ${(props) =>
      props.maxwidthinit ? props.maxwidthinit + 'px' : 'auto'};
    min-height: ${(props) => {
      if (props.minheightinit) {
        if (props.minheightinit === 'auto') {
          return 'auto';
        }
        return props.minheightinit + 'px';
      }
      return '710px';
    }};
    padding: ${(props) => (props.bp ? '8px 24px' : '0')};
  }
  .title {
    /* padding: 10px 16px 10px 29px; */
    padding: ${(props) =>
      props.pageSource === 'coupon'
        ? '0'
        : props.pageSource === 'session'
        ? '10px 32px 10px 32px'
        : '10px 16px 10px 29px'};
    /* padding-bottom: 0; */
    background-color: ${(props) =>
      props.pageSource === 'coupon'
        ? '#E5E5E5'
        : props.pageSource === 'session'
        ? '#ffffff'
        : props.theme.palette.primary.main};
    h2 {
      height: 28px;
      width: 100%;
    }
    .card-icon-style {
      width: 36px;
      height: 36px;
      color: #ffffff;
      background-color: ${(props) => props.theme.palette.primary.main};
      border-radius: 50%;
      padding: 7px;
      box-sizing: border-box;
      margin-right: 16px;
    }
    .card-icon-name {
      font-size: 30px;
      color: ${(props) => props.theme.palette.primary.main};
      letter-spacing: 0;
    }
  }
  .content {
    /* padding: 16px 24px; */
    padding: 16px 24px 0 16px;
    font-size: 16px;
    color: rgba(97, 97, 97, 100);
    .MuiTypography-body1 {
      margin-bottom: 0;
      width: 100%;
      line-height: 20px;
    }
    .tab-wrap {
      border: 1px solid ${(props) => props.theme.palette.primary.main};
      border-radius: 4px;
      display: inline-block;
      .tab-button {
        background-color: #ffffff;
        font-size: 20px;
        color: #757575;
        letter-spacing: 0;
        box-shadow: none;
        font-weight: normal;
        /* width: 136px; */
        padding: 16px 48px;
        height: 56px;
        white-space: nowrap;
        width: auto;
      }
      .tab-button-right {
        border-right: 1px solid ${(props) => props.theme.palette.primary.main};
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .active {
        color: ${(props) => props.theme.palette.primary.main};
        font-weight: 400;
      }
    }
    .sp-ty-edit-style {
      font-size: 20px;
      color: #000000;
    }
    .sp-paper-style {
      padding: 20px 0;
      box-sizing: border-box;
      width: 100%;
      background-color: #f5f5f5;
      .sp-ty-between-money-style {
        width: 177px;
      }
      .sp-textfield-wrap {
        background-color: #ffffff;
      }
    }
  }
  .buttonWrapper {
    display: ${(props) =>
      props?.buttonStyle?.display ? props.buttonStyle.display : 'flex'};
    height: ${(props) =>
      props?.buttonStyle?.height ? props.buttonStyle.height : '90px'};
    padding: ${(props) =>
      props?.buttonStyle?.padding
        ? props.buttonStyle.padding
        : '24px 24px 66px 24px'};
    justify-content: flex-end;
    .delete {
      background: #666464;
    }
    .save {
      margin-left: 12px;
      background: ${(props) => props.theme.palette.primary.main};
      width: ${(props) =>
        props.sureName
          ? 'auto'
          : props.theme.components.MuiButton.styleOverrides.root.width};
    }

    .ensure-button {
      position: relative;

      .buttonProgress {
        color: ${(props) => props.theme.palette.off.main};
        position: absolute;
        top: 28%;
        left: 50%;
      }
    }

    .MuiButton-contained.Mui-disabled {
      background-color: #212121;
    }
  }
  .icon-font-size {
    width: 28px;
    height: 28px;
  }
  .sp-formula-select-button-size-style {
    width: 72px;
    .MuiButton-startIcon {
      margin-right: 0;
    }
  }
  .sp-table-style {
    width: 70px !important;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
  }
  .sp-table-active-style {
    color: ${(props) => props.theme.palette.primary.main};
  }
  .sp-table-divider-style {
    background-color: #9e9e9e;
  }
  .sp-tab-three-input-style {
    background: #ffffff;
    border: 1px solid #cfd8dc;
    border-radius: 4px;
    letter-spacing: 0;
    width: 440px;
    height: 56px;
    padding-left: 22px;
    padding-right: 22px;
  }
  .sp-arrow-right-altIcon-style {
    width: 24px;
    color: #05bb8b;
    margin-left: 16.5px;
    margin-right: 16.5px;
  }
  .dia-home-input-style {
    .MuiOutlinedInput-root {
      height: auto;
    }
  }
  .creat-form-dia-wrap {
    .paper-style {
      padding: 24px 48px;
      box-sizing: border-box;
      width: 100%;
      .MuiInput-underline::after {
        border-bottom: none;
      }
      .MuiInput-underline::before {
        border-bottom: none;
      }
    }
    .paper-background {
      background-color: #f5f5f5;
    }
    .MuiFormControlLabel-label {
      margin-left: 15px;
      font-size: 20px;
      color: #757575;
      letter-spacing: 0;
    }
    .formula-special-button-style {
      width: 90px;
      height: 30px;
      padding-left: 0;
      padding-right: 0;
      background: #ffffff;
      border: 1px solid ${(props) => props.theme.palette.primary.main};
      border-radius: 4px;
      text-align: center;
      font-weight: normal;
      color: ${(props) => props.theme.palette.primary.main};
      font-size: 13px;
    }
    .popover-style {
      position: absolute;
      top: -30px;
      left: 100px;
      background: #ffffff;
      box-shadow: 0 0 16px 0 rgba(69, 90, 100, 0.2);
      border-radius: 8px;
      width: 360px;
      z-index: 1;
      padding: 48px 24px 24px;
      .MuiFormControlLabel-label {
        margin-left: 15px;
        font-size: 15px;
        color: #212121;
        letter-spacing: 0;
      }
      .check-box-style {
        padding: 0 9px;
      }
    }
    .popover-title {
      font-size: 13px;
      color: #424242;
      letter-spacing: 0;
    }
    .popover-choose-wrap-style {
      width: 100%;
      background-color: #ffffff;
      border-radius: 4px;
      padding: 12px;
      box-sizing: border-box;
    }
    .popover-choose-item-wrap {
      width: 104px;
      font-size: 14px;
      color: #000000;
      letter-spacing: 0;
      padding: 6px 8px 6px 12px;
      background-color: #e0e0e0;
      border-radius: 16px;
      .close-icon-font-size {
        width: 16px;
        height: 16px;
        margin-left: 12px;
        vertical-align: text-bottom;
      }
    }
    .keyboard-date-picker-wrap {
      .MuiFormControl-marginNormal {
        margin: 0;
        background-color: #ffffff;
      }
      .MuiInput-underline:after {
        border: none;
      }
      .MuiInput-underline:before {
        border: none;
      }
      .MuiInput-underline {
        border: 1px solid #9e9e9e;
        border-radius: 4px;
        padding-left: 14px;
        .MuiInputBase-input::placeholder {
          color: #616161;
        }
      }
    }
  }
  .button-onlyIcon-style {
    width: 72px;
    .icon-font-size {
      width: 28px;
      height: 28px;
    }
    .MuiButton-startIcon {
      margin-right: 0;
    }
  }
  .formula-tip-icon-style {
    width: 36px;
    height: 36px;
    color: #00c853;
  }
  .formula-tip-message-style {
    font-size: 17px;
    color: #747474;
    letter-spacing: 0;
  }
  .task-icon-style {
    width: 36px;
    height: 36px;
    background-color: #00c853;
    color: #ffffff;
    border-radius: 50%;
    padding: 7px;
    margin-right: 16px;
  }
  .steps-wrap {
    .step-circle-one {
      background-color: ${(props) => props.theme.palette.primary.main};
      color: #ffffff;
      .label {
        color: ${(props) => props.theme.palette.primary.main};
        font-size: 17px;
      }
      .des {
        font-size: 11px;
        color: #212121;
      }
    }
    .step-circle-two {
      background-color: #000000;
      color: #ffffff;
      .label {
        color: #000000;
        font-size: 17px;
      }
      .des {
        font-size: 11px;
        color: #212121;
      }
    }
    .step-circle-three {
      background-color: #ffffff;
      border: 1px solid #cccccc;
      color: #cccccc;
      .label {
        color: #cccccc;
        font-size: 17px;
      }
      .des {
        font-size: 11px;
        color: #cccccc;
      }
    }
    .step-line {
      height: 2px;
      background-color: #cccccc;
    }
    .active {
      background-color: ${(props) => props.theme.palette.primary.main};
    }
    .transform-style {
      transform: translateX(-50%);
    }
  }
  .styleOverrides {
    font-size: 18px;
  }
  .coupon-dialog-title-style,
  .coupon-dialog-close-icon-style {
    /* color: #666464; */
    color: #ffffff;
  }
  .coupon-dialog-title-init-style,
  .coupon-dialog-close-icon-init-style {
    color: #ffffff;
  }
  .table-dialog-width-style {
    width: 842px;
  }
  .init-tabs-wrap-style {
    .init-tab-style {
      color: #666464;
      font-size: 16px;
      background-color: #ffffff;
    }
    .Mui-selected {
      color: #ffffff;
      background-color: ${(props) => props.theme.palette.primary.main};
    }
  }
  .init-tabs-wrap > .MuiBox-root {
    padding: 0;
  }
  .text-align-right {
    input {
      text-align: right;
    }
    input::placeholder {
      text-align: right;
    }
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
`;

export default DialogMLStyled;
